<div class="full-height layout-column">

  <div class="flex layout-column">
    <chat-conversations-list *ngIf="!activeConversation"
                             class="flex fade-element-in-only"
                             [conversations]="conversations"
                             (onUserSelect)="onUserSelect($event)"
                             (onConversationSelect)="onConversationSelect($event)"
                             (onClose)="onCloseChat()">

    </chat-conversations-list>

    <chat-conversation-view *ngIf="!!activeConversation"
                            class="flex fade-element-in-only"
                            [conversation]="activeConversation"
                            [enableBack]="true"
                            [enableClose]="true"
                            (onBack)="onCloseActiveConversation($event)"
                            (onClose)="onCloseChat()">

    </chat-conversation-view>

  </div>

</div>
